
import React from 'react';
import './InsightsSection.css';

const InsightsSection = () => {
  const insights = [
    {
      category: 'Trend Watch',
      title: 'Sustainable Materials in Modern Homes',
      meta: 'Focus: Eco-friendly finishes and low-impact sourcing',
      image:
        'https://images.unsplash.com/photo-1505691938895-1758d7feb511?w=800&h=480&fit=crop'
    },
    {
      category: 'Project Spotlight',
      title: 'Optimizing Small Living Spaces',
      meta: 'Case study: Multi-functional layouts for city apartments',
      image:
        'https://images.unsplash.com/photo-1520607162513-77705c0f0d4a?w=800&h=480&fit=crop'
    },
    {
      category: 'Case Study',
      title: 'Reimagining Corporate Workspaces',
      meta: 'How design is reshaping the modern office for 2024 and beyond',
      image:
        'https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=800&h=480&fit=crop'
    }
  ];

  return (
    <section className="insights-section">
      <div className="insights-container">
        <div className="insights-header">
          <div>
            <h2 className="insights-title">Spotlight: Industry Insights</h2>
            <p className="insights-subtitle">
              Stay updated with the latest trends and case studies.
            </p>
          </div>
          <a href="/" className="insights-link">
            Visit Content Hub
          </a>
        </div>
        <div className="insights-grid">
          {insights.map((insight, index) => (
            <article key={index} className="insight-card">
              <div className="insight-image-wrap">
                <img
                  src={insight.image}
                  alt={insight.title}
                  className="insight-image"
                />
              </div>
              <div className="insight-body">
                <span className="insight-pill">{insight.category}</span>
                <h3 className="insight-title">{insight.title}</h3>
                <p className="insight-meta">{insight.meta}</p>
              </div>
              <div className="insight-footer">
                <a href="/" className="insight-read-link">
                  Read Article
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsSection;
